var map = {
	"./banking-open-api/banking-open-api-cover.jpg": "64ce",
	"./banking-open-api/open-apis-benefits.svg": "71528",
	"./banking-open-api/open-apis-practices.svg": "e114",
	"./banking-open-api/open-apis.svg": "0084",
	"./benovelty_onedegree_fiberapi_20201112/images/20201112-banner.jpg": "1a04",
	"./benovelty_onedegree_fiberapi_20201112/images/cyber-insurance-faq.jpg": "da7d",
	"./benovelty_onedegree_fiberapi_20201112/images/press-cover.jpg": "ae05",
	"./case-study/hsbc/hsbc-background.jpg": "85ac",
	"./case-study/hsbc/hsbc-blog-cover.jpg": "c75f",
	"./case-study/hsbc/hsbc-cover.jpg": "f515",
	"./case-study/hsbc/hsbc-gallery.jpg": "ef3a",
	"./case-study/hsbc/hsbc-video-thumbnail.jpg": "22ee",
	"./pastwebinars/banners/20200317_open_API_technology_entrepreneurial_journey_sharing.jpg": "62f0",
	"./pastwebinars/banners/20200514_api_trends_and_challenges.jpg": "2dbc",
	"./pastwebinars/banners/20200515_opportunity-for-education-industry-digital-transformation.jpg": "add1",
	"./pastwebinars/banners/20200623_benovelty_taptab_boutir.jpg": "ecd6",
	"./pastwebinars/banners/20200724_local_start-up_experience_sharing.jpg": "5aa8",
	"./pastwebinars/banners/20200907_future_of_law_legal_innovations_in_action_today.jpg": "5f00",
	"./pastwebinars/banners/20201022_executive_seminar_technologies_in_finance.jpg": "4fb7",
	"./pastwebinars/banners/20201102_driving_innovations_in_open_banking.jpg": "57a5",
	"./pastwebinars/banners/20201103_fintech_and_the_new_normal.jpg": "2294",
	"./pastwebinars/banners/20201112_benovelty_onedegree_fiberapi.jpg": "0d83",
	"./pastwebinars/banners/20210329_aws_techconnect_series.png": "28d0",
	"./pastwebinars/banners/20210812-benovelty-dbs-xero.jpg": "7f76",
	"./pastwebinars/gallery/20200515-1.jpg": "baa4",
	"./pastwebinars/gallery/20200515-2.jpg": "4715",
	"./pastwebinars/gallery/20200515-3.jpg": "4472",
	"./pastwebinars/gallery/20200515-4.jpg": "34cf",
	"./pastwebinars/gallery/20200623-1.jpg": "e20f",
	"./pastwebinars/gallery/20200623-2.jpg": "e9e5",
	"./pastwebinars/gallery/20200623-3.jpg": "81fd",
	"./pastwebinars/gallery/20200623-4.jpg": "f4dc",
	"./pastwebinars/gallery/20201102-1.jpg": "dc6f",
	"./pastwebinars/gallery/20201102-2.jpg": "6abe",
	"./pastwebinars/gallery/20201102-3.jpg": "f6de",
	"./pastwebinars/gallery/20201102-4.jpg": "e6b7",
	"./pastwebinars/gallery/20201112-1.jpg": "8c16",
	"./pastwebinars/gallery/20201112-2.jpg": "fdd1",
	"./pastwebinars/gallery/20201112-3.jpg": "940c",
	"./pastwebinars/gallery/20201112-4.jpg": "eb35",
	"./pastwebinars/organisers/aws.png": "fd0e",
	"./pastwebinars/organisers/benovelty.png": "5d4b",
	"./pastwebinars/organisers/boutir.png": "44b2",
	"./pastwebinars/organisers/cfte.png": "9932",
	"./pastwebinars/organisers/cyberport.png": "557f",
	"./pastwebinars/organisers/dbs.png": "f67c",
	"./pastwebinars/organisers/f5.png": "7970",
	"./pastwebinars/organisers/fiberapi.png": "5548",
	"./pastwebinars/organisers/hkqaa.png": "afa1",
	"./pastwebinars/organisers/hkstp.png": "8ac0",
	"./pastwebinars/organisers/hong_kong_society_for_quality.png": "8d4c",
	"./pastwebinars/organisers/hsbc.png": "75ad",
	"./pastwebinars/organisers/onedegree.png": "233d",
	"./pastwebinars/organisers/taptab.png": "8606",
	"./pastwebinars/organisers/the_law_society_of_hong_kong.png": "b586",
	"./pastwebinars/organisers/ust_entrepreneurship_center.png": "0ce4",
	"./pastwebinars/organisers/xero.png": "86e2",
	"./webinars/banners/20201112_benovelty_onedegree_fiberapi.jpg": "736a",
	"./webinars/banners/20210812-benovelty-dbs-xero.jpg": "98d6",
	"./webinars/banners/20211209-steps-to-build-your-successful-ecommerce-kingdom.jpg": "ba60",
	"./webinars/gallery/20201112-1.jpg": "fab1",
	"./webinars/gallery/20201112-2.jpg": "09b8",
	"./webinars/gallery/20201112-3.jpg": "5273",
	"./webinars/gallery/20201112-4.jpg": "11c1",
	"./webinars/organisers/benovelty.png": "b0f8",
	"./webinars/organisers/dbs.png": "a785",
	"./webinars/organisers/migather.png": "9856",
	"./webinars/organisers/solution_forest.png": "0211",
	"./webinars/organisers/xero.png": "e79f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42c4";